import dayjs from 'dayjs'

export const formatShortDate = (iso?: string | null): string => {
  if (!iso) return '-'
  return dayjs(iso).format('MMM D, YYYY')
}

export const formatDate = (dateString: string) => {
  const date = new Date(Date.parse(dateString.replace(/(st|nd|rd|th)/, '')))

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  let hours = date.getUTCHours()
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')

  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12

  return `${year}-${month}-${day} ${hours}:${minutes} ${ampm} UTC`
}

export const formatDateLocal = (dateString: string) => {
  const date = new Date(Date.parse(dateString.replace(/(st|nd|rd|th)/, '')))

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}`
}

export const formatTimeStamp = (timestamp: string | number) => {
  return timestamp ? new Date(Number(timestamp) * 1000).toLocaleString() : 0
}

export const convertDateToString = (date: Date, isShort = false) => {
  if (date === undefined) date = new Date()

  const datetime = new Date(date)
  const year = datetime.getUTCFullYear()
  const month = datetime.getUTCMonth() + 1
  const day = datetime.getUTCDate()
  const strDay = String(day).padStart(2, '0')
  let hours = datetime.getUTCHours()
  const minutes = String(datetime.getUTCMinutes()).padStart(2, '0')

  let h_prefix = 'AM'
  if (hours >= 12) {
    h_prefix = 'PM'
    if (hours > 12) hours = hours - 12
  } else if (hours === 0) hours = 12

  const strHours = String(hours).padStart(2, '0')

  let d_prefix = 'th'
  if (day === 1 || day === 21 || day === 31) d_prefix = 'st'
  else if (day === 2 || day === 22) d_prefix = 'nd'
  else if (day === 3 || day === 23) d_prefix = 'rd'

  let _month = ''
  switch (month) {
    case 1:
      _month = 'Jan'
      break
    case 2:
      _month = 'Feb'
      break
    case 3:
      _month = 'Mar'
      break
    case 4:
      _month = 'Apr'
      break
    case 5:
      _month = 'May'
      break
    case 6:
      _month = 'Jun'
      break
    case 7:
      _month = 'Jul'
      break
    case 8:
      _month = 'Aug'
      break
    case 9:
      _month = 'Sep'
      break
    case 10:
      _month = 'Oct'
      break
    case 11:
      _month = 'Nov'
      break
    case 12:
      _month = 'Dec'
      break
    default:
      break
  }

  if (isShort) return `${_month} ${strDay}${d_prefix} ${year}`

  return `${strHours}:${minutes} ${h_prefix} UTC, ${_month} ${strDay}${d_prefix} ${year}`
}

/**
 * Format timestamp in milliseconds to date string using existing formatDate function
 */
export const formatDateFromTimestampMs = (timestampMs: number): string => {
  if (!timestampMs) return '-'
  const dateString = new Date(timestampMs).toISOString()
  return formatDate(dateString)
}

/**
 * Format date with custom format
 * @param dateString ISO date string
 * @param format format pattern like 'dd/mm/yyyy hh:mm'
 */
export const formatDateWithPattern = (
  dateString: string,
  format: string = 'DD/MM/YYYY HH:mm'
): string => {
  if (!dateString) return '-'
  return dayjs(dateString).format(format)
}
